webpackJsonp([102560910324591],{

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookAuth = __webpack_require__(34);
	
	var _LoreHookAuth2 = _interopRequireDefault(_LoreHookAuth);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookAuth2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Installation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'First install the hook:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      npm install lore-hook-auth --save\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then add the hook to your ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'index.js'
	      ),
	      ' file.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Because this hook generates a reducer, you also need to modify the dependencies array of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'redux'
	      ),
	      ' hook in order to make sure it runs ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'after'
	      ),
	      ' this hook, so that the reducer is guaranteed to exist when the Redux store is built.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // index.js\n      import actions from \'lore-hook-actions\';\n      import auth from \'lore-hook-auth\';\n      import collections from \'lore-hook-collections\';\n      import models from \'lore-hook-models\';\n      import reducers from \'lore-hook-reducers\';\n      import redux from \'lore-hook-redux\';\n\n      lore.summon({\n        hooks: {\n          auth,\n          actions,\n          collections,\n          models,\n          reducers,\n          redux: _.extend(redux, {\n            dependencies: [\'reducers\', \'auth\']\n          })\n        }\n      });\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-auth-installation-js-0e8108b0c53eb1682d4c.js